import { AutoAwesome, ExpandMore } from "@mui/icons-material";
import {
  Box,
  FormControl,
  Grid2,
  InputAdornment,
  MenuItem,
  Select,
  TableCell,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import DnaIco from "../../../../assets/icons/DnaIco";
import PuzzleIco from "../../../../assets/icons/PuzzleIco";
import SocksIco from "../../../../assets/icons/SocksIco";
import Haley from "../../../../assets/images/Haley.png";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import SnackBar from "../../../../component/SnackBar";
import {
  DotColor,
  StatusChange,
  StyledFlexRowView,
} from "../../../common-components/StyledComponents";
import IgnitePopup from "./IgnitePopup";
import CommonTable from "./CommonTable";

function AssembleTeamTableList({ isEdit, handleClickVerify }) {
  const [selectedRows, setSelectedRows] = useState([]);
  const [checkedRow, setCheckedRow] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [sortedData, setSortedData] = useState([
    {
      id: "100",
      team: "Salesforce Project Manager",
      cost: "$200",
      reqLevel: "Senior",
      req: "1",
      recLevel: "Junior",
      rec: "0.75",
      location: "Onsite",
      allocation: "100%",
    },
    {
      id: "101",
      team: "Salesforce Business Analyst/Administrator",
      cost: "$2500",
      reqLevel: "Senior",
      req: "1",
      recLevel: "Senior",
      rec: "0.2",
      location: "India",
      allocation: "100%",
    },
    {
      id: "102",
      team: "Salesforce Developer",
      cost: "$6000",
      reqLevel: "Mid-Level",
      req: "1",
      recLevel: "Mid-Level",
      rec: "1.5",
      location: "Hybrid",
      allocation: "100%",
    },
    {
      id: "103",
      team: "Salesforce Architect",
      cost: "$2000",
      reqLevel: "Mid-Level",
      req: "1",
      recLevel: "Mid-Level",
      rec: "0.5",
      location: "India",
      allocation: "100%",
    },
    {
      id: "104",
      team: "Salesforce Quality Assurance Analyst",
      cost: "$150",
      reqLevel: "Mid-Level",
      req: "1",
      recLevel: "Mid-Level",
      rec: "1",
      location: "Romania",
      allocation: "100%",
    },
    {
      id: "105",
      team: "DevOps Personnel",
      cost: "$150",
      reqLevel: "NA",
      req: "1",
      recLevel: "Mid-Level",
      rec: "0.5",
      location: "India",
      allocation: "100%",
    },
  ]);
  const [mileStonesTableData, setMileStonesTableData] = useState([
    {
      id: "100",
      team: "Salesforce Project Manager",
      cost: "$200",
      reqLevel: "NA",
      req: "1",
      recLevel: "Junior",
      rec: "0.75",
      location: "Onsite",
      allocation: "75%",
    },
    {
      id: "101",
      team: "Salesforce Business Analyst/Administrator",
      cost: "$2500",
      reqLevel: "NA",
      req: "1",
      recLevel: "Senior",
      rec: "0.2",
      location: "India",
      allocation: "20%",
    },
    {
      id: "102",
      team: "Salesforce Developer",
      cost: "$6000",
      reqLevel: "NA",
      req: "2",
      recLevel: "Mid-Level",
      rec: "1.5",
      location: "Hybrid",
      allocation: "100%",
    },
    {
      id: "103",
      team: "Salesforce Architect",
      cost: "$2000",
      reqLevel: "NA",
      req: "1",
      recLevel: "Mid-Level",
      rec: "0.5",
      location: "India",
      allocation: "50%",
    },
    {
      id: "104",
      team: "Salesforce Quality Assurance Analyst",
      cost: "$150",
      reqLevel: "NA",
      req: "1",
      recLevel: "Mid-Level",
      rec: "1",
      location: "Romania",
      allocation: "60%",
    },
    {
      id: "105",
      team: "DevOps Personnel",
      cost: "$150",
      reqLevel: "NA",
      req: "1",
      recLevel: "Mid-Level",
      rec: "0.5",
      location: "India",
      allocation: "20%",
    },
  ]);

  const [helixDialogOpen, setHelixDialogOpen] = useState({
    inviteOpen: false,
    shareLoading: false,
    inviteLoading: false,
    activateOpen: false,
    backtoJobsLoading: false,
    disabled: false,
    roleLoading: false,
  });
  const [jobDialogOpen, setJobDialogOpen] = useState({
    inviteOpen: false,
    shareLoading: false,
    inviteLoading: false,
    activateOpen: false,
    backtoJobsLoading: false,
    disabled: false,
    roleLoading: false,
  });
  const [jigsawDialogOpen, setJigsawDialogOpen] = useState({
    inviteOpen: false,
    shareLoading: false,
    inviteLoading: false,
    activateOpen: false,
    backtoJobsLoading: false,
    disabled: false,
    roleLoading: false,
  });
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  const [formData, setFormData] = useState({
    designation: "",
    seniority: "",
    resourceCount: "",
    hrs: "",
    location: "",
  });

  const handleChangeText = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Track the index of the row being dragged
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragEnter = (targetIndex) => {
    if (draggedIndex !== null && draggedIndex !== targetIndex) {
      const updatedData = [...sortedData];
      const [draggedRow] = updatedData.splice(draggedIndex, 1);
      updatedData.splice(targetIndex, 0, draggedRow);
      setSortedData(updatedData);
      setDraggedIndex(targetIndex);
    }
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  const headerData = ["Title", "Seniority", "Allocation", "Location", "Cost"];
  const mileStonesHeaderData = [
    "Title",
    "Required",
    "Seniority",
    "Location",
    "Members",
    // "",
  ];

  const statusOptions = [
    { label: "Junior", color: "#9E77ED" },
    { label: "Mid-Level", color: "#F04438" },
    { label: "Senior", color: "#17B26A" },
    { label: "NA", color: "#A0A0A0" },
  ];

  const locationOptions = [
    { label: "India", color: "#9E77ED" },
    { label: "Romania", color: "#F04438" },
    { label: "Hybrid", color: "#F04438" },
    { label: "Onsite", color: "#17B26A" },
  ];

  const handleMilesTableBodyData = (row, index) => {
    return (
      <>
        {/* <TableCell>{row.id}</TableCell> */}
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.team}
        </TableCell>
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.req}
        </TableCell>
        <TableCell>
          <FormControl>
            <Select
              value={row.recLevel || ""}
              displayEmpty
              renderValue={(selected) => {
                const selectedOption = statusOptions.find(
                  (option) => option.label === selected
                );

                if (!selectedOption) {
                  return (
                    <Typography sx={{ color: "#A0A0A0" }}>
                      Select Level
                    </Typography>
                  );
                }

                return (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: selectedOption.color,
                        marginRight: "8px",
                      }}
                    />
                    <Typography>{selectedOption.label}</Typography>
                  </Box>
                );
              }}
              IconComponent={ExpandMore}
              sx={{
                "& .MuiSelect-select": {
                  paddingLeft: "10px !important",
                  paddingTop: "1px !important",
                  paddingBottom: "1px !important",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "6px",
                  paddingRight: "25px !important",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#D0D5DD",
                  boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                },
                "& .MuiSelect-icon": {
                  fontSize: "14px",
                },
              }}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.label} value={option.label}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: option.color,
                        marginRight: "8px",
                      }}
                    />
                    {option.label}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
        <TableCell>
          <FormControl>
            <Select
              value={row.location || ""}
              displayEmpty
              renderValue={(selected) => {
                const selectedOption = locationOptions.find(
                  (option) => option.label === selected
                );

                if (!selectedOption) {
                  return (
                    <Typography sx={{ color: "#A0A0A0" }}>
                      Select Level
                    </Typography>
                  );
                }

                return (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: selectedOption.color,
                        marginRight: "8px",
                      }}
                    />
                    <Typography>{selectedOption.label}</Typography>
                  </Box>
                );
              }}
              IconComponent={ExpandMore}
              sx={{
                "& .MuiSelect-select": {
                  paddingLeft: "10px !important",
                  paddingTop: "1px !important",
                  paddingBottom: "1px !important",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "6px",
                  paddingRight: "25px !important",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#D0D5DD",
                  boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                },
                "& .MuiSelect-icon": {
                  fontSize: "14px",
                },
              }}
            >
              {locationOptions.map((option) => (
                <MenuItem key={option.label} value={option.label}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: option.color,
                        marginRight: "8px",
                      }}
                    />
                    {option.label}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>

        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.reqLevel === "Jesse Matthews - 92%"
                  ? "#17B26A"
                  : row.status === "SalesForce BA"
                  ? "#9E77ED"
                  : row.status === "Available" || row.status === "Active"
                  ? "green"
                  : "#F04438"
              }
            />
            {row.reqLevel}
            {/* <IconButton sx={{ padding: 0 }}>
              <ChevronDownIco width={"16px"} height={"16px"} />
            </IconButton> */}
          </StatusChange>
        </TableCell>
        {/* <TableCell>
          <DotsVerticalIco />
        </TableCell> */}
      </>
    );
  };

  // const handleRowCheckboxChange = (rowId, row) => {
  //   setSelectedRows((prevSelectedRows) =>
  //     prevSelectedRows.includes(rowId)
  //       ? prevSelectedRows.filter((id) => id !== rowId)
  //       : [...prevSelectedRows, rowId]
  //   );
  //   setCheckedRow(row);
  // };

  const handleRowCheckboxChange = (selectedRowIds) => {
    setSelectedRows(selectedRowIds); // Directly update selected row IDs

    // Convert selectedRowIds (Set) into an array of row objects
    const selectedRowsData = mileStonesTableData.filter((row) =>
      selectedRowIds.has(row.id)
    );

    setCheckedRow(selectedRowsData);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setFormData({
      designation: "",
      senority: "",
      resourceCount: "",
      hrs: "",
      location: "",
    });
  };

  const handleClickAddTeam = () => {
    setOpenDialog(true);
  };

  const handleAddTeam = () => {
    const newTeamMember = {
      id: (mileStonesTableData.length + 100).toString(),
      team: formData.designation,
      cost: "$$$$",
      recLevel: formData.seniority,
      resources: formData.resourceCount,
      hrs: formData.hrs,
      reqLevel: "NA",
      location: formData?.location,
    };

    setMileStonesTableData((prevData) => [...prevData, newTeamMember]);
    handleCloseDialog();
  };

  const handleOpenHelix = () => {
    if (!checkedRow?.length) {
      setSnackbarState({
        open: true,
        message: "Select any one",
        severity: "error",
      });
    } else {
      setHelixDialogOpen((prev) => ({
        ...prev,
        activateOpen: true,
      }));
    }
  };

  const handleHelixPopupClose = () => {
    setHelixDialogOpen({
      inviteOpen: false,
      shareLoading: false,
      inviteLoading: false,
      activateOpen: false,
      backtoJobsLoading: false,
      disabled: false,
    });
  };

  const handleJobPopupClose = () => {
    setJobDialogOpen({
      inviteOpen: false,
      shareLoading: false,
      inviteLoading: false,
      activateOpen: false,
      backtoJobsLoading: false,
      disabled: false,
    });
  };

  const handleCloseValidation = () =>
    setSnackbarState((prev) => ({ ...prev, open: false }));
  console.log(checkedRow, "selectedRows");

  const handleOpenJigsaw = () => {
    if (!checkedRow?.length) {
      setSnackbarState({
        open: true,
        message: "Select any one",
        severity: "error",
      });
    } else {
      setJigsawDialogOpen((prev) => ({
        ...prev,
        activateOpen: true,
      }));
    }
  };

  const handleJisawPopupClose = () => {
    setJigsawDialogOpen({
      inviteOpen: false,
      shareLoading: false,
      inviteLoading: false,
      activateOpen: false,
      backtoJobsLoading: false,
      disabled: false,
    });
  };

  const handleAssignTeam = () => {
    setMileStonesTableData((prevData) =>
      prevData.map((item) =>
        item.id === "100"
          ? { ...item, reqLevel: "Jesse Matthews - 92%" }
          : item.id === "103"
          ? { ...item, reqLevel: "Sushir Singh - 96%" }
          : item
      )
    );
  };

  const handleHelixButtonClick = () => {
    setJobDialogOpen((prev) => ({
      ...prev,
      activateOpen: true,
    }));
    setHelixDialogOpen((prev) => ({
      ...prev,
      activateOpen: false,
    }));
  };

  return (
    <Grid2 container spacing={4}>
      <Grid2 size={12}>
        <StyledFlexRowView style={{ gap: "30px" }}>
          <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
            {"Assemble Team"}
          </Typography>
          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="700"
            value="Mark as verified"
            padding="8px 15px"
            onClick={handleClickVerify}
          />
        </StyledFlexRowView>
      </Grid2>

      <Grid2 size={12}>
        <CommonTable
          data={mileStonesTableData}
          columns={mileStonesHeaderData}
          // sortedColumns={sortableColumns}
          onSortChange={(col) => console.log("Sort by", col)}
          onRowCheckboxChange={handleRowCheckboxChange}
          handleTableBodyData={handleMilesTableBodyData}
          withCheckbox={true}
          marginTop={"0px"}
        />
      </Grid2>

      <Grid2 size={12} sx={{ display: "flex", justifyContent: "center" }}>
        <StyledFlexRowView>
          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="700"
            value="Assign Team from Candidate Hub"
            padding="8px 15px"
            startIcon={<SocksIco isWhite />}
            onClick={handleAssignTeam}
          />
          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="700"
            value="Activate Jobs to use Helix"
            padding="8px 15px"
            onClick={handleOpenHelix}
            startIcon={<DnaIco isWhite />}
          />
          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="700"
            value="Launch Jigsaw for Fit Analysis"
            padding="8px 15px"
            onClick={handleOpenJigsaw}
            startIcon={<PuzzleIco isWhite />}
          />
        </StyledFlexRowView>
      </Grid2>

      <Grid2 item size={{ xs: 12 }}>
        <CommonTextField
          border={"0.5px solid #EAECF0"}
          padding={15}
          placeholder={"Ask Haley anything"}
          bgColor={"#F7F8F9"}
          startIcon={
            <InputAdornment position="start">
              <img src={Haley} />
            </InputAdornment>
          }
          endComponent={
            <CommonButton
              // onClick={() => setAi(!ai)}
              fontWeight={600}
              padding={"8px 25px"}
              value={"Ask Haley"}
              endIcon={<AutoAwesome />}
            />
          }
        />
      </Grid2>

      <IgnitePopup
        activateDialogOpen={helixDialogOpen.activateOpen}
        title={"Launch Helix to create Jobs "}
        subTitle={
          "New jobs will be opened based on the skill requirement in the Proposal"
        }
        buttonName={"Launch Helix"}
        handleActivateDialogClose={handleHelixPopupClose}
        icon={<DnaIco />}
        isButtonClick={true}
        handleButtonClick={handleHelixButtonClick}
      />

      <IgnitePopup
        activateDialogOpen={jobDialogOpen.activateOpen}
        title={"Jobs created successfully"}
        // subTitle={
        //   "New jobs will be opened based on the skill requirement in the Proposal"
        // }
        buttonName={"Ok"}
        handleActivateDialogClose={handleJobPopupClose}
        icon={<DnaIco />}
        children={
          <>
            {checkedRow?.map((row, index) => (
              <Typography
                key={index}
                sx={{ fontSize: "14px", marginBottom: "10px" }}
              >
                {`${index + 1}. Job No: ${index + 5} has been created for `}
                <strong>{row?.team}</strong>
              </Typography>
            ))}
          </>
        }
      />

      <IgnitePopup
        activateDialogOpen={jigsawDialogOpen.activateOpen}
        title={"Launch Jigsaw for Fit Analysis"}
        subTitle={
          "Thank you submitting this Fit Analysis will be sent to you once it's done!"
        }
        buttonName={"Launch Jigsaw"}
        handleActivateDialogClose={handleJisawPopupClose}
        icon={<PuzzleIco />}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </Grid2>
  );
}

export default AssembleTeamTableList;
